import { Count } from "@/components/shared/data-table/total-count";
import { useCompanyPayableInvoicesToReviewLiveCountsSubscription } from "@/queries/invoices/live-counts/company/company-payable-invoices-to-review-live-counts";
import { useTransfersLiveCountsSubscription } from "@/queries/invoices/live-counts/company/transfers-live-counts";
import { useAccountingTransactionsReadyToExportLiveCount } from "@/queries/transactions/live-counts/accounting-transactions-ready-to-export-live-count";
import { useAccountingTransactionsTodosLiveCount } from "@/queries/transactions/live-counts/accounting-transactions-todos-live-count";
import { useTransactionsTodosLiveCount } from "@/queries/transactions/live-counts/transactions-todos-live-count";

export const TransactionsBadge = () => {
  const { liveCounts, loading } = useTransactionsTodosLiveCount();

  if (loading || liveCounts === 0) {
    return null;
  }

  return <Count count={liveCounts} variant="warning" />;
};

export const AccountingTransactionsTodosBadge = () => {
  const { liveCounts, loading } = useAccountingTransactionsTodosLiveCount();

  if (loading || liveCounts === 0) {
    return null;
  }

  return <Count count={liveCounts} variant="warning" />;
};

export const AccountingTransactionsReadyToExportBadge = () => {
  const { liveCounts, loading } =
    useAccountingTransactionsReadyToExportLiveCount();

  if (loading || liveCounts === 0) {
    return null;
  }

  return <Count count={liveCounts} variant="warning" />;
};

export const PayableInvoicesToReviewBadge = () => {
  const { liveCounts, loading } =
    useCompanyPayableInvoicesToReviewLiveCountsSubscription();

  if (loading || liveCounts === 0) {
    return null;
  }

  return <Count count={liveCounts} variant="warning" />;
};

export const TransfersBadge = () => {
  const { liveCounts, loading } = useTransfersLiveCountsSubscription();

  if (loading || liveCounts === 0) {
    return null;
  }

  return <Count count={liveCounts} variant="warning" />;
};
